import FormType from "../../../../../../Components/Form/FormType";
import Url from "../../../../../../Services/Url";

const AddBillingFormOptions = (init) => {
	const contract = init.contract || {};
	const { billingInformation = {}, contractSign } = contract;
	const disabled = !!contractSign; // Disable if contractSign exists

	return {
		Extra: {
			id: billingInformation?.id || null,
		},
		Fields: [
			[
				{
					element: FormType.Input,
					required: true,
					label: "Firstname",
					placeholder: "Enter firstname",
					value: billingInformation?.firstname,
					name: "firstname",
					disabled: disabled,
				},
				{
					element: FormType.Input,
					required: true,
					label: "Lastname",
					placeholder: "Enter lastname",
					value: billingInformation?.lastname,
					name: "lastname",
					disabled: disabled,
				},
			],
			[
				{
					element: FormType.Input,
					required: true,
					label: "Email",
					placeholder: "Enter email",
					value: billingInformation?.email,
					name: "email",
					disabled: disabled,
				},
				{
					element: FormType.Input,
					required: true,
					label: "Phone",
					placeholder: "Enter phone",
					value: billingInformation?.phone,
					name: "phone",
					disabled: disabled,
				},
			],
			{
				element: FormType.Select,
				required: true,
				label: "Company",
				placeholder: "Enter company",
				options: { url: Url.company.all, id: "id", name: "name" },
				value: billingInformation?.company,
				name: "company",
				disabled: disabled,
			},
			[
				{
					element: FormType.Input,
					required: false,
					label: "State / Province / Territory",
					placeholder: "Enter state",
					value: billingInformation?.state,
					name: "state",
					disabled: disabled,
				},
				{
					element: FormType.Input,
					required: false,
					label: "Country",
					placeholder: "Enter country",
					value: billingInformation?.country,
					name: "country",
					disabled: disabled,
				},
			],
			[
				{
					element: FormType.Input,
					required: false,
					label: "City",
					placeholder: "Enter city",
					value: billingInformation?.city,
					name: "city",
					disabled: disabled,
				},
				{
					element: FormType.Input,
					required: false,
					label: "Postal / Zipcode",
					placeholder: "Enter postal code",
					value: billingInformation?.postalCode,
					name: "postalCode",
					disabled: disabled,
				},
			],
			{
				element: FormType.Input,
				required: true,
				label: "Address",
				placeholder: "Enter address",
				value: billingInformation?.address,
				name: "address",
				disabled: disabled,
			},
		],
	};
};

export default AddBillingFormOptions;
